import React from 'react';
import {useTranslation} from 'react-i18next';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCFileInput from '../../../components/Simple/SMCFileInput';
import EmptyRow from '../../../components/Simple/EmptyRow';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function ImageWizardBody({
    onCancel,
    onFinish,
    wizardVars
}) {
    const { t } = useTranslation();
    
    const {
        name, setName,
        fileData, setFileData,
    } = wizardVars;

    return (
        <>
            <SMCModalBody labelWidth={200}>
                <div style={{ lineHeight: '20px' }}>
                    <SMCLabel>{t('SMP.NEW_CUSTOM_IMAGE_TMP_WIZ.LINE1')}</SMCLabel>
                    <SMCLabel>{t('SMP.NEW_CUSTOM_IMAGE_TMP_WIZ.LINE2')}</SMCLabel>
                </div>
                <EmptyRow />
                {/* Name */}
                <SMCTextInput
                    label={t('SMP.NAME')}
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
                {/* File data */}
                <SMCFileInput
                    value={fileData}
                    onChange={files => setFileData(files)}
                    label={t('SMC_GUI_DATA')}
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </>
    );
}

export default ImageWizardBody;